import React from "react";
import { Box, createStyles, withStyles } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import MagicLinkButton from "./MagicLinkButton.web";
import { StepProgressContext } from "./StepProgressContext";
import { getProgressRatio } from "./stepProgress";
import {
  alignedGutter,
  magicLinkColors,
  magicLinkLayout,
  magicLinkRadius
} from "./magicLinkTokens";

interface Props {
  onBack?: () => void;
  onNext?: () => void;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  nextLabel?: string;
  nextType?: "button" | "submit";
  hideBack?: boolean;
  backId?: string;
  nextId?: string;
  classes: Record<string, string>;
}

const styles = (theme: any) =>
  createStyles({
    footer: {
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: theme.zIndex.appBar,
      height: magicLinkLayout.footerHeight,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      gap: 64,
      padding: `8px ${alignedGutter(24)}`,
      backgroundColor: magicLinkColors.page,
      borderTop: `1px solid ${magicLinkColors.divider}`,
      [theme.breakpoints.down("sm")]: {
        gap: 24,
      },
      [theme.breakpoints.down("xs")]: {
        gap: 12,
        padding: `8px ${alignedGutter(16)}`,
      },
    },
    side: {
      flex: "0 0 auto",
      minWidth: 73,
      display: "flex"
    },
    sideEnd: {
      justifyContent: "flex-end"
    },
    track: {
      flex: 1,
      height: 10,
      borderRadius: magicLinkRadius.button,
      backgroundColor: magicLinkColors.border,
      overflow: "hidden"
    },
    bar: {
      height: "100%",
      borderRadius: magicLinkRadius.button,
      backgroundColor: theme.palette.primary.main,
      transition: "width 300ms ease"
    }
  });

const StepFooter = ({
  onBack,
  onNext,
  nextDisabled,
  nextLoading,
  nextLabel = "Next",
  nextType = "button",
  hideBack,
  backId = "stepBackButton",
  nextId = "stepNextButton",
  classes
}: Props) => {
  const progress = React.useContext(StepProgressContext);
  const ratio = getProgressRatio(progress);
  return (
    <Box className={classes.footer} data-testid="step-footer">
      <Box className={classes.side}>
        {!hideBack && (
          <MagicLinkButton
            variant="outline"
            onClick={onBack}
            id={backId}
            className="statucBackButton"
            startIcon={<ChevronLeftIcon style={{ fontSize: 18 }} />}
          >
            Back
          </MagicLinkButton>
        )}
      </Box>
      <Box
        className={classes.track}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(ratio * 100)}
      >
        <Box className={classes.bar} style={{ width: `${ratio * 100}%` }} />
      </Box>
      <Box className={`${classes.side} ${classes.sideEnd}`}>
        <MagicLinkButton
          type={nextType}
          onClick={nextType === "submit" ? undefined : onNext}
          disabled={nextDisabled}
          loading={nextLoading}
          id={nextId}
          className="statucNextButton"
          endIcon={<ChevronRightIcon style={{ fontSize: 18 }} />}
        >
          {nextLabel}
        </MagicLinkButton>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(StepFooter);
